import axiosInstance from '../config/axios.js';

const API_BASE = '/alerts';

const alertService = {
  // Get unread count
  getUnreadCount: async (userId) => {
    const response = await axiosInstance.get(`${API_BASE}/user/${userId}/unread-count`);
    return response.data;
  },

  // Get unread alerts
  getUnread: async (userId) => {
    const response = await axiosInstance.get(`${API_BASE}/user/${userId}/unread`);
    return response.data;
  },

  // Get read alerts
  getRead: async (userId) => {
    const response = await axiosInstance.get(`${API_BASE}/user/${userId}/read`);
    return response.data;
  },

  // Mark single alert as read
  markAsRead: async (alertId) => {
    const response = await axiosInstance.post(`${API_BASE}/${alertId}/read`);
    return response.data;
  },

  // Mark all alerts as read
  markAllAsRead: async (userId) => {
    const response = await axiosInstance.post(`${API_BASE}/user/${userId}/mark-all-read`);
    return response.data;
  },

  // Delete single alert
  deleteAlert: async (alertId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${alertId}`);
    return response.data;
  },

  // Delete all unread alerts
  deleteAllUnread: async (userId) => {
    const response = await axiosInstance.delete(`${API_BASE}/user/${userId}/delete-all-unread`);
    return response.data;
  },

  // Delete all read alerts
  deleteAllRead: async (userId) => {
    const response = await axiosInstance.delete(`${API_BASE}/user/${userId}/delete-all-read`);
    return response.data;
  }
};

export default alertService;